export default __webpack_public_path__ + "static/eating-1b44b1f951cc591d41e5e3356e8c12ac.svg";